import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchFiles, getFile } from "../redux/actions/fileActions";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  Typography,
} from "@mui/material";
import { windowsTableStyles } from "../styles/windowsTableStyles";
import { smallBold, smallTitle } from "../styles/typography";
import Avatar from "@mui/material/Avatar";



const tableStyles = windowsTableStyles();
const OfficeMembersAndParties = () => {
  const { t } = useTranslation(['common']);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { file } = useSelector((state) => state.fileDetails);
  const { user } = useSelector((state) => state.userLoaded); // Assuming user info is stored in auth state
  const { files } = useSelector((state) => state.fileList);

  useEffect(() => {
    dispatch(fetchFiles);
    dispatch(getFile(id));
  }, [dispatch, id]);

  useEffect(() => {
    console.log("File data:", file);
  }, [file]);

  const handleRowClick = (item) => {
    // if (
    //   user.role === "Manager" ||
    //   (user.role === "Responsible Lawyer" && item.type !== "Lawyer")
    // ) {

      const currentFile = files.find((file) => file._id === id);
      const owner = currentFile ? currentFile.officeMembers[0].member : null;
      navigate(`/relationships/${item._id}`, { state: { caseId: id, owner } });
    // }
  };



  const getTabData = () => {
    if (!file)
      return {
        lawyers: [],
        clients: [],
        payingParties: [],
        oppositeParties: [],
        advocateOppositeParties: [],
      };
    const lawyers = file?.officeMembers?.map((member) => ({
      ...member.member,
      type: "Lawyer",
    }));
    console.log("file", file);
    const clients = file?.parties?.filter((party) => party.type === "Client")
      .map((party) => ({
        ...party.name,
        type: "Client",
        displayName:
          party.name.contractType === "Individual"
            ? `${party.name.firstName} ${party.name.middleName ? party.name.middleName + " " : ""
            }${party.name.lastName}`
            : party.name.businessName,
      }));
    const payingParties = file?.parties?.filter((party) => party.type === "Paying Party")
      .map((party) => ({
        ...party.name,
        type: "Paying Party",
        displayName:
          party.name.contractType === "Individual"
            ? `${party.name.firstName} ${party.name.middleName ? party.name.middleName + " " : ""
            }${party.name.lastName}`
            : party.name.businessName,
      }));
    const oppositeParties = file?.parties?.filter((party) => party.type === "Opposite Party")
      .map((party) => ({
        ...party.name,
        type: "Opposite Party",
        displayName:
          party.name.contractType === "Individual"
            ? `${party.name.firstName} ${party.name.middleName ? party.name.middleName + " " : ""
            }${party.name.lastName}`
            : party.name.businessName,
      }));
    const advocateOppositeParties = file?.parties?.filter((party) => party.type === "Advocate Opposite Party")
      .map((party) => ({
        ...party.name,
        type: "Advocate Opposite Party",
        displayName:
          party.name.contractType === "Individual"
            ? `${party.name.firstName} ${party.name.middleName ? party.name.middleName + " " : ""
            }${party.name.lastName}`
            : party.name.businessName,
      }));
    return {
      lawyers,
      clients,
      payingParties,
      oppositeParties,
      advocateOppositeParties,
    };

  };


  const getStatusColor = (status) => {
    switch (status) {
      case t('common:inactive'):
      case "Inactive":
        return "#e5202e";  // Red for Inactive
      case t('common:active'):
      case "Active":
        return "#85bc20";  // Green for Active
      default:
        return "transparent";  // Transparent if no status
    }
  };

  const {
    lawyers,
    clients,
    payingParties,
    oppositeParties,
    advocateOppositeParties,
  } = getTabData();

  const renderTableRows = (data, sectionTitle) => {
    return (
      <>
        <TableRow>
          <TableCell
            colSpan={4}
            sx={{ ...smallBold, textTransform: 'capitalise' }}
          >
            {sectionTitle}
          </TableCell>
        </TableRow>
        {data?.map((item) => (
          <TableRow
            key={item._id}
            onClick={() => handleRowClick(item)}
            sx={{
              ...tableStyles.row,
             
            }}
          >

            <TableCell sx={{ ...tableStyles.cell, cursor: "pointer",
                            "&:hover": {
                              textDecoration: "underline !important",
                              cursor: "pointer",
                            },
                            color: "#005b92", }}>
              {item ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Avatar
                    alt={item.contractType === "Individual" ? item.firstName : item.businessName}
                    src={item.avatar ? item.avatar : ""}
                    sx={{
                      fontFamily: '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                      fontSize: "7.8px",
                      height: "1rem",
                      width: "1rem",
                      marginRight: "-2px",

                    }}
                  >
                    {!item.avatar &&
                      `${item.contractType === "Individual"
                        ? `${item.firstName.charAt(0)}${item.middleName ? item.middleName.charAt(0) : item.lastName.charAt(0)}`
                        : item.businessName.charAt(0)}`}
                  </Avatar>
                  {item.contractType === "Individual"
                    ? `${item.firstName} ${item.middleName ? item.middleName + " " : ""}${item.lastName}`
                    : item.businessName}
                </Box>
              ) : (
                "N/A"
              )}
            </TableCell>


            <TableCell sx={{ ...tableStyles.cell }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box
                  sx={{
                    padding: "1px 6px",
                    borderRadius: "20px",
                    backgroundColor: getStatusColor(item.status), // Dynamic color based on status
                    color: item.status === "Active" ? "black" : "white", // White text inside the badge
                    fontSize: "8.25px",
                    fontFamily: '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                    fontWeight: "700",
                    textTransform: "upperCase",
                    height: "12px",
                    letterSpacing: "0.2em"
                  }}
                >
                  {item?.status === 'Active' ? t('common:active') : item?.status === 'Inactive' ? t('common:inactive') : item?.status}
                </Box>
              </Box>
            </TableCell>
            <TableCell sx={tableStyles.cell}>
              {item.contacts.length > 0 ? item.contacts[0].phone : t('common:fallbacks.notAvailable')}
            </TableCell>
            <TableCell sx={tableStyles.cell}>
              {item.contacts.length > 0 ? item.contacts[0].email : t('common:fallbacks.notAvailable')}
            </TableCell>
          </TableRow>
        ))}
      </>
    );
  };

  return (
    <Box sx={{ backgroundColor: "white", padding: "32px 24px " }}>
      <Table
        sx={{ ...tableStyles.container, border: "1px solid #d1d1d1" }}
        size="small"
      >
        <TableHead>
          <TableRow>
            <TableCell sx={tableStyles.headerCell}>{t('forms:labels.fullName')}</TableCell>
            <TableCell sx={tableStyles.headerCell}>{t('forms:labels.status')}</TableCell>
            <TableCell sx={tableStyles.headerCell}>{t('forms:labels.phone')}</TableCell>
            <TableCell sx={tableStyles.headerCell}>{t('forms:labels.email')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {renderTableRows(lawyers, t('common:lawyers'))}
          {renderTableRows(clients, t('common:clients'))}
          {renderTableRows(payingParties, t('common:paying_parties'))}
          {renderTableRows(oppositeParties, t('common:opposite_parties'))}
          {renderTableRows(
            advocateOppositeParties,
            t('common:advocate_opposite_parties')
          )}
        </TableBody>
      </Table>
    </Box>
  );
};

export default OfficeMembersAndParties;
